<script>
import { saveUserSession } from '@shared/utils/sessionHandover'
import settings from '@shared/settings'
import { getQueryParams } from '@shared/utils/url'

export default {
  methods: {
    async redirectToApp(path, query = {}) {
      const token = await saveUserSession()
      window.location = new URL(this.getDynamicLink(path, { ...query, ...token }))
    },
    getDynamicLink(path, query) {
      // For the keys, see https://firebase.google.com/docs/dynamic-links/create-manually
      const params = {
        link: `${settings.dynamicLinkTargetBaseUrl()}${path}?${getQueryParams(query)}`,
        apn: `${settings.androidAppPkgName()}`,
        ibi: `${settings.iosAppBundleId()}`,
        isi: `${settings.iosAppStoreId()}`
      }
      return `${settings.dynamicLinkBaseUrl()}/?${getQueryParams(params)}`
    }
  }
}
</script>
